// 导入组件
import MyInput from './MyInput'
import MyAlert from './MyAlert'
import MyLink from './MyLink'
import MySwitch from './MySwitch'
import MyFormItem from './MyFormItem'
import MyForm from './MyForm'
import MyButton from './MyButton'
import MyDialog from './MyDialog'
import MyMessage from './MyMessage'

// 导入 字体样式
import '../style/font.css'

export default function (Vue) {
  // 注册全局组件
  // console.log(MyInput.name)
  // Vue.component('组件名')
  Vue.component(MyInput.name, MyInput)
  Vue.component(MyAlert.name, MyAlert)
  Vue.component(MyLink.name, MyLink)
  Vue.component(MySwitch.name, MySwitch)
  Vue.component(MyFormItem.name, MyFormItem)
  Vue.component(MyForm.name, MyForm)
  Vue.component(MyButton.name, MyButton)
  Vue.component(MyDialog.name, MyDialog)
  // Vue.component(MyMessage.name, MyMessage)

  // 添加原型方法
  Vue.prototype.$message = function ({ title, duration }) {
    // 生成构造函数
    const MMConstructor = Vue.extend(MyMessage)
    // 实例化message组件对象
    const message = new MMConstructor()
    message.title = title
    message.duration = duration
    // message.isShow = true
    // 生成dom元素
    message.$mount()
    // console.log(message)
    // console.log(message.$el)
    // 设置显示
    message.isShow = true
    // 添加到页面上
    document.body.appendChild(message.$el)
    setTimeout(() => {
      message.isShow = false
      // setTimeout(() => {
      //   document.body.removeChild(message.$el)
      // }, 100)
    }, duration)
  }
}
